(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'LivePlannerCustomPricing',
	};

    $(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

    form.load = function load()
	{
        console.log("pricing form loaded");
    };

    form.success = function success(response)
	{
        if (!Adzuki.Form.hasError(response)) {
            $('.modal').modal('hide');

            Adzuki.StatusMessage('Success', 'Pricing Successfully Shared.');
        }
        
        return false;
    };
}(jQuery, window.Adzuki || {}));